import React, {ReactElement} from "react";

const Separator = (): ReactElement => {
    return (
        <div className="py-4">
            <div className="w-full border-t border-gray-300"/>
        </div>
    );
};

export default Separator;